<template>
  <div>
    <div class="primary font-semibold pb-3">
      Timeline
    </div>
    <Timeline
      class="custom-timeline"
      :timelineEvents="orderTimeline"
      :finalPointColour="orderStatusToColorMap[orderStatus]"
      textSmall
    />
  </div>
</template>
<script setup lang="ts">
import Timeline from '@/components/timeline.vue';
import { orderStatusToColorMap } from '@/helpers/category_color_mapper';

interface Props {
  orderTimeline: { eventType: string; eventAt: string }[];
  orderStatus: string;
}

defineProps<Props>();
</script>

<style scoped lang="scss">

.custom-timeline :deep .content {
  @apply text-base;
}

</style>
